export default "<template>\n\n  <KButton\n    primary\n    disabled\n    text=\"Primary Button\"\n    appearance=\"flat-button\"\n  />\n\n</template>\n";